import { render, staticRenderFns } from "./subgroup.vue?vue&type=template&id=253a3aa2"
import script from "./subgroup.vue?vue&type=script&lang=js"
export * from "./subgroup.vue?vue&type=script&lang=js"
import style0 from "./subgroup.vue?vue&type=style&index=0&id=253a3aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports